/**
* @ComponentFor Avensia.Shop.Features.Shared.Partials.PropertyTypes.Html
*/
/* eslint-disable react/no-multi-comp */
import React from 'react';
import Image from 'Shared/ImageFallback';
import { isBrowser } from 'Shared/device-type';
import loadScript, { unloadScript } from 'Shared/load-script';
import editorAttributesFor from 'Shared/editor-attributes-for';
import { resolveSyncIfLoadedOrThrow } from '@avensia/nitro5-scope';
function renderHtmlTag(item, i, componentProps) {
    if (item.tag) {
        const attr = Object.assign({ key: i }, item.attr);
        if (item.tag === 'img') {
            let props = Object.assign({}, attr);
            let size = 'large';
            if (props['data-size']) {
                size = props['data-size'];
            }
            if (componentProps.keepImageSizes !== true) {
                if (props.width) {
                    delete props.width;
                }
                if (props.height) {
                    delete props.height;
                }
            }
            return React.createElement(Image, Object.assign({}, props, { size: size }));
        }
        else if (item.tag === 'style') {
            // https://github.com/facebook/react/issues/7093
            return React.createElement(item.tag, attr, item.children[0]);
        }
        else if (item.tag === 'script') {
            if (isBrowser()) {
                return (React.createElement("noscript", { key: attr.key, ref: el => {
                        const anyEl = el;
                        if (el) {
                            if (item.children && !anyEl.loaded) {
                                anyEl.loaded = true;
                                try {
                                    console.debug('Evaluating inline script', item.children[0]);
                                    eval(item.children[0]);
                                }
                                catch (e) {
                                    window['console']['error'] && window['console']['error'](e);
                                }
                            }
                            else if (attr.src && !anyEl.loaded) {
                                anyEl.loaded = true;
                                console.debug('Loading script', attr.src);
                                loadScript(attr.src);
                            }
                        }
                        else if (attr.src) {
                            console.debug('Unloading script', attr.src);
                            unloadScript(attr.src);
                        }
                    } }));
            }
            else {
                // We don't want to include a script tag when running on the server because that will cause the script
                // to load once again when the client dehydates the render tree. This has the slight disadvantage that
                // scripts will load first when everything else is up and ready and not when the browser parses the initial
                // server rendered DOM, but it's much simpler this way.
                return React.createElement("noscript", { key: attr.key });
            }
        }
        else {
            return React.createElement(item.tag, attr, item.children && item.children.map((childItem, j) => renderHtmlTag(childItem, j, componentProps)));
        }
    }
    else if (item.componentName) {
        const Component = resolveSyncIfLoadedOrThrow(item.componentName);
        const model = Object.assign({ key: i }, item);
        return React.createElement(Component, model);
    }
    else {
        return item;
    }
}
const Html = (props) => React.createElement(props.tagName, editorAttributesFor(props.propertyName, props.className), props.html && props.html.map((item, i) => renderHtmlTag(item, i, props)));
Html.supportsPropertyForIntegration = true;
export default Html;
